// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".1afbf9adbddf7fb3058ee473f65e931075dfddce.chunk.js";
};